/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_SpeedInputs */

const vi_tracking_speed = /** @type {(inputs: Tracking_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tốc độ`)
};

/**

* @param {Tracking_SpeedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_speed = /** @type {((inputs?: Tracking_SpeedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_SpeedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_speed(inputs)
});